import * as auth from "./auth";
import * as db from "./db";
import * as firebase from "./firebase";

export { auth, db, firebase };


// WEBPACK FOOTER //
// ./src/firebase/index.ts